import { fetchNotifications } from '../../api/notifications.api';
import { queryKeys } from '../../queryKeys';
import { useInfiniteQuery } from '../base';

export function useInfiniteNotifications() {
  const { queryKey } = queryKeys.notifications.fetchInfiniteNotifications();
  return useInfiniteQuery({
    initialPageParam: '1',
    meta: { limit: '20' },
    queryFn: async (context: any) =>
      fetchNotifications({ limit: '20', page: context.pageParam ?? '1' }),
    queryKey,
  });
}
